// @config
import { xervixApi, xervixApiMultipart } from "../config/axios.config";

// @constants
import { API_ROUTES } from "../constants/apiRoutes";
import { IFormDataCompany } from "../types/professional.types";

// @types
import { UserInfo, ProfessionalInfo, ILocation } from "../types/profile.types";

const fetchProfessionalInfo = async (
  professionalId: string
): Promise<ProfessionalInfo> => {
  const response = await xervixApi.get(
    API_ROUTES.PROFILE.GET_PROFESSIONAL_INFO(professionalId)
  );
  return response.data;
};

const fetchUserTypeInfo = async (): Promise<UserInfo> => {
  try {
    const userType = "USER";
    const URL = `${API_ROUTES.PROFILE.GET_BY_USER_TYPE_INFO(userType)}`;
    const response = await xervixApi.get<UserInfo>(URL);
    return response.data;
  } catch (error: any) {
    throw new Error("Error al obtener el perfil");
  }
};

const fetchProfessionalTypeInfo = async (): Promise<ProfessionalInfo> => {
  try {
    const userType = "PROFESSIONAL";
    const URL = `${API_ROUTES.PROFILE.GET_BY_USER_TYPE_INFO(userType)}`;
    const response = await xervixApi.get<ProfessionalInfo>(URL);
    return response.data;
  } catch (error: any) {
    throw new Error("Error al obtener el perfil");
  }
};

const getLogoForCompany = async (id: string) => {
  const token = localStorage.getItem('accessToken');
  const url = `${process.env.REACT_APP_APPSERVER_API_URL}${API_ROUTES.PROFESSIONAL.DOWNLOAD_DOCUMENT(id)}`
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Accept": "image/",
      "Authorization": `Bearer ${token}`
    },
  })
    .then((response) => response.blob())
    .then((blob) => {
      const imageUrl = URL.createObjectURL(blob);
      return imageUrl;
    })
    .catch(() => {
      return ""
    });

  return response;
}

const getLogoByPost = async (postId: string) => {
  const token = localStorage.getItem('accessToken');
  const url = `${process.env.REACT_APP_APPSERVER_API_URL}${API_ROUTES.POST.GET_IMAGE_POST(postId)}`
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Accept": "image/",
      "Authorization": `Bearer ${token}`
    },
  })
    .then((response) => response.blob())
    .then((blob) => blob)
    .catch(() => "");

  return response;
}

const updateProfile = async (form: IFormDataCompany, userType: string, userId: string): Promise<IFormDataCompany | void> => {
  try {
    const response = await xervixApi.patch(API_ROUTES.PROFILE.UPDATE_PROFILE(userType, userId), form);
    return response.data;
  } catch (error) {
    throw error;
  }
}

const updateLogoForCompany = async (logo: FormData): Promise<ILocation> => {
  try {
    const response = await xervixApiMultipart.put(API_ROUTES.PROFILE.UPDATE_LOGO, logo);
    return response.data;
  } catch (error) {
    throw error;
  }
}

const methodsProfile = {
  fetchProfessionalInfo,
  fetchUserTypeInfo,
  fetchProfessionalTypeInfo,
  getLogoForCompany,
  getLogoByPost,
  updateProfile,
  updateLogoForCompany
};

export default methodsProfile;
